module.exports = __webpack_public_path__ + "static/csc-2-872b35852501e119c1f9b0d2ea9f2f5f.jpg";